import jpeg from 'jpeg-js';

export default function decode(input: Uint8Array): Uint8Array {
  // DCTDecode is only used for JPEGS, which will be displayed as images
  return input;
}
